import { isNumber } from '@shared/utils/number';
import type { AggregationFn, AggregationType } from './types';

export const filteredRowAggregationFn: AggregationFn<any> = (
  type,
  { table, column }
) => {
  const rows = table.getFilteredRowModel().rows;

  if (rows.length === 0) {
    return undefined;
  }

  const values = rows
    .map((row) => row.getValue(column.columnDef.id ?? 'foo'))
    .filter(isNumber);

  return resolvers[type](values);
};

const resolvers: Record<
  AggregationType,
  (values: number[]) => number | undefined
> = {
  avg: (values) => {
    const sum = values.reduce((total, value) => total + value, 0);
    return values.length === 0 ? undefined : sum / values.length;
  },
  min: (values) => {
    return values.length === 0 ? undefined : Math.min(...values);
  },
  max: (values) => {
    return values.length === 0 ? undefined : Math.max(...values);
  },
  sum: (values) => {
    return values.reduce((total, value) => total + value, 0);
  },
};
